// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3EgVW","title":"AfterBackImages_title__3LZTa","images":"AfterBackImages_images__1KpqQ"};